<h2 mat-dialog-title>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.GENERATE_FROM_CURL' | translate }}</h2>
<mat-dialog-content>
  <glxy-form-field class="curl-input">
    <textarea matInput placeholder="Paste cURL..." [formControl]="curlCommand" rows="6"></textarea>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
  <button mat-flat-button color="primary" (click)="import()">
    {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.GENERATE' | translate }}
  </button>
</mat-dialog-actions>
